import { render } from "./LoadingBars.vue?vue&type=template&id=2bc37594&scoped=true"
import script from "./LoadingBars.vue?vue&type=script&lang=js"
export * from "./LoadingBars.vue?vue&type=script&lang=js"

import "./LoadingBars.vue?vue&type=style&index=0&id=2bc37594&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc37594"]])

export default __exports__